import React, { useState, useEffect } from 'react';
import Network from '../../../models/Network.js';
import AccordionListElement from '../list_elements/AccordionListElement.js';
import ReportTimeline from '../graphics/ReportTimeline';
import './Module.css';

const key = process.env.REACT_APP_CLIENT_ACCESS_KEY;
const URLS = require("../../../urls.js");

const StatusCodes = require('../../../status-codes/status-codes.js')
const ErrorCodes = require('../../../error-codes/error-codes.js')

const ReportDataModule = ({user, reportId, isSmallScreen}) => {
    const [reportXml, setReportXml] = useState(null);
    const [reportJson, setReportJson] = useState(null);
    const [reportObject, setReportObject] = useState(null);
    const [reportSchemaMessages, setReportSchemaMessages] = useState(null);

    // function that gets one reports from the server
    const getOneReport = async (reportId) => {
        const url = URLS.GET_ONE_REPORT;
        const dict = {
            uid: user.uid,
            report_id: reportId,
            CLIENT_ACCESS_KEY: key
        };
        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;
            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something
            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")
            } else {
                console.log("Unknown Error")
            }
        });
        return responseData;
    };

    useEffect(() => {
        getOneReport(reportId)
            .then((data) => {
                try {
                    const parsedJSON = JSON.parse(data[0].report_json);
                    setReportJson(parsedJSON);

                    // setReportSchemaMessages(JSON.parse(data[0].report_schema_messages));
                    // setReportXml(data[0].report_xml);
                    setReportObject(JSON.parse(data[0].report_object));
                } catch (error) {
                    console.log('Error parsing JSON:', error);
                    setReportJson(null);
                    setReportSchemaMessages(null);
                    setReportXml(null);
                    setReportObject(null);
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, []);

    return (
        <div className={isSmallScreen ? "standard-module-screen-small" : "standard-module"}>
            {reportJson ? (
                <AccordionListElement reportJSON={reportJson} />
            ) : (
                <div>Loading Report Data...</div>
            )}
            {/* <div>
                <h2 className='module-title'>Report XML</h2>
                <pre>{reportXml}</pre>
            </div> */}
            {/* <div>
                <h2 className='module-title'>Report Timeline</h2>
                {reportObject ? (
                    <>
                        <ReportTimeline reportData={reportObject} />
                    </>
                ) : (
                    <div>Loading Timeline...</div>
                )}
            </div>
            <div>
                <h2 className='module-title'>Report Object</h2>
            </div>
            {reportObject ? (
                <AccordionListElement reportJSON={reportObject} />
            ) : (
                <div>Loading Report Object...</div>
            )} */}
            {/* <div>
                <h2 className='module-title'>Report Schema Messages</h2>
            </div>
            {reportSchemaMessages ? (
                <AccordionListElement reportJSON={reportSchemaMessages} />
            ) : (
                <div>Loading Report Schema Messages...</div>
            )} */}
        </div>
    );
}

export default ReportDataModule; 